/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { DocumentsListPage } from './DocumentsListPage'
import { DOCUMENTS_VIEW_TYPE } from './types'

interface FavoritesPageProps {
  isCommonFav?: boolean
}

export const FavoritesPage: React.FC<FavoritesPageProps> = (props) => {
  return <DocumentsListPage key="favorites" viewType={DOCUMENTS_VIEW_TYPE.favorites} isCommonFav={props.isCommonFav} />
}
